import { render } from "./DashboardPrimaryCare.vue?vue&type=template&id=4b6d530a&lang=pug"
import script from "./DashboardPrimaryCare.vue?vue&type=script&lang=js"
export * from "./DashboardPrimaryCare.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__